export default function eventsFilters(){
  // Dropdowns
  const toggleEventFilterLeague = () => {
    $('.filter-wrapper.league').toggleClass('active')
  }

  const toggleEventFilterTime = () => {
    $('.filter-wrapper.time').toggleClass('active')
  }
  
  $('.side.league .filter-trigger').click(function(e){
    e.preventDefault()
    $(this).toggleClass('active')
    toggleEventFilterLeague()
  })

  $('.side.time .filter-trigger').click(function(e){
    e.preventDefault()
    $(this).toggleClass('active')
    toggleEventFilterTime()
  })

  // Event filter league
  $('.filter-wrapper.league ul li a').click(function(e){
    e.preventDefault()
    toggleEventFilterLeague()
    document.querySelectorAll('.filter-wrapper.league ul li a').forEach(link => link.classList.remove('active'))
    $(this).addClass('active')
    const targetLeague = $(this).attr('href')
    if(targetLeague === 'supercros'){
      document.querySelector('.callendar').classList.add('filter-sx')
      document.querySelector('.callendar').classList.remove('filter-mx')
      document.querySelector('.callendar').classList.remove('filter-smx')      
      document.querySelector('.callendar').classList.remove('filter-all')
    } else if(targetLeague === 'motocross'){
      document.querySelector('.callendar').classList.add('filter-mx')
      document.querySelector('.callendar').classList.remove('filter-sx')
      document.querySelector('.callendar').classList.remove('filter-smx')      
      document.querySelector('.callendar').classList.remove('filter-all')
    } else if(targetLeague === 'supermotocros'){
      document.querySelector('.callendar').classList.add('filter-smx')
      document.querySelector('.callendar').classList.remove('filter-sx')
      document.querySelector('.callendar').classList.remove('filter-mx')      
      document.querySelector('.callendar').classList.remove('filterall')
    } else{
      document.querySelector('.callendar').classList.add('filter-all')
      document.querySelector('.callendar').classList.remove('filter-sx')
      document.querySelector('.callendar').classList.remove('filter-mx')
      document.querySelector('.callendar').classList.remove('filter-smx')
    }
  })

  // Event filter time
  $('.filter-wrapper.time ul li a').click(function(e){
    e.preventDefault()
    toggleEventFilterTime()
    const targetLeague = $(this).attr('href')
    if(targetLeague === 'upcoming'){
      document.querySelector('.callendar').classList.add('filter-time-upcoming')
      document.querySelector('.callendar').classList.remove('filter-time-past')
      $('.side.time .filter-trigger span').html('Upcoming')
    } else if(targetLeague === 'past-events'){
      document.querySelector('.callendar').classList.remove('filter-time-upcoming')
      document.querySelector('.callendar').classList.add('filter-time-past')
      $('.side.time .filter-trigger span').html('Past Events')
    }
  })
}